<template>
    <div class="modal fade" :id="'customerDetailsModal' + contact.id" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="margin: auto; max-width: 2000px;">
        <div class="modal-dialog" role="document" style="max-width: 2000px;">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title">Contact Details</h4>
                </div>
                <div class="modal-body" align="left">
                    <div v-if="roleName.role_id !== 1" style="padding: 0; margin: 0;">
                        <table class="table table-hover" style="text-align: left; vertical-align: middle; font-size: 14px;">
                            <tr class="info" style="font-weight: bold;">
                                <td style="vertical-align: middle; border-bottom: 10px solid transparent" colspan="2">{{ contact.first_name+' '+contact.last_name }}</td>
                            </tr>
                            <!-- Repeat for each phone number and email -->
                            <tr v-for="(phone, index) in contact.customer_numbers" :key="index">
                                <td>
                                    <i v-if="phone.fullNumber" class="fa fa-mobile-phone" aria-hidden="true"></i>&nbsp;
                                    <a v-if="isMobile" :href="generateCallLink(phone.fullNumber)">{{ phone }}</a>
                                    <span v-else-if="phone.fullNumber">{{ phone.fullNumber }}</span>
                                </td>
                            </tr>
                            <!-- Email fields -->
                            <tr v-if="contact.email1">
                                <td><i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;{{ contact.email1 }}</td>
                            </tr>
                            <tr v-if="contact.email2">
                                <td><i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;{{ contact.email2 }}</td>
                            </tr>
                            <tr v-if="contact.email3">
                                <td><i class="fa fa-envelope" aria-hidden="true"></i>&nbsp;{{ contact.email3 }}</td>
                            </tr>
                        </table>
                    </div>
                    <div v-else>
                        <p>You must use the app to contact the customer</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CustomerDetailsModal",
    props: {
        contact: {
            type: Object,
            required: true
        },
        roleName: {
            type: Object,
            required: true
        },
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        generateCallLink(phoneNumber) {
            return `tel:${phoneNumber}`;
        }
    }
}
</script>
<style scoped>

</style>